<template>
  <div class="">
    <div v-if="this.$route.path=='/monitor/monitorWarning'">
      <screening-item ref="screeningRef" @screeningItemNum="projectChange"></screening-item>
      <div class="page-title">头条</div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="规则管理" name="first">
          <!-- 规则管理模块 -->
          <el-row>
            <el-col :span="6" v-permission="'monitor:accountMonitorList'">
              <div class="grid-content " :class="pageType===3?'active':''" @click="typeClick(3)">
                <img :src="imgArr.imgStr1" alt="">
                <div class="grid-name">全局预警</div>
              </div>
            </el-col>
            <el-col :span="6" v-permission="'monitor:getAiMonitorList'">
              <div class="grid-content" :class="pageType===1?'active':''" @click="typeClick(1)">
                <img :src="imgArr.imgStr2" alt="">
                <div class="grid-name">新建智能托管</div>
              </div>
            </el-col>
            <el-col :span="6" v-permission="'monitor:getAiMonitorList'">
              <div class="grid-content" :class="pageType===2?'active':''" @click="typeClick(2)">
                <img :src="imgArr.imgStr3" alt="">
                <div class="grid-name">控制广告止损</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content" @click="$message.warning('此功能待开发')">
                <img :src="imgArr.imgStr4" alt="">
                <div class="grid-name">增加预算</div>
              </div>
            </el-col>
          </el-row>
          <!-- 已创建的自动规则--表格 -->
          <div v-if="pageType === 3">
            <div class="table-name">已创建的自动规则</div>
            <div class="clearfix">
              <el-button @click="addWarning('add')" type="primary" class="fr" size="medium" icon="iconfont icon-tianjia-copy"
              v-permission="'monitor:addAccountMonitor'">新建规则</el-button>
              <el-dropdown @command="handleCommand" class="fr" style="margin-right:10px;">
                <el-button :disabled="handleSelection.length == 0" type="primary" size="medium" class="" style="margin-left:0;">
                  批量修改状态<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="enable"> 启用 </el-dropdown-item>
                  <el-dropdown-item command="disable"> 暂停 </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <el-table class="center-table roleTable" v-loading="tableLoading" :key="itemkey"
              :data="rulesTableData" @selection-change="handleSelectionChange"
              border
              style="width: 100%">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column
                width="80px"
                prop="status"
                label="运行/暂停">
                <template slot-scope="scope">
                  <el-switch @change="changeStatus($event,scope.row)" v-model="scope.row.status" :active-value="1" :inactive-value="0"></el-switch>
                </template>
              </el-table-column>
              <el-table-column
                prop="accountName"
                label="投放账户">
              </el-table-column>
              <el-table-column
                prop="configuratorName"
                label="创建者">
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="创建时间">
              </el-table-column>
              <el-table-column
                prop="updateName"
                label="修改者">
              </el-table-column>
              <el-table-column
                prop="updateTime"
                label="修改时间">
              </el-table-column>
              <el-table-column
                width="160px"
                prop=""
                label="操作">
                <template slot-scope="scope">
                  <el-button v-if="mgUpdateAccountMonitor || updateAccountMonitor" @click="addWarning('edit',scope.row)" type="text">编辑</el-button>
                  <el-button v-permission="'monitor:accountMonitorDetail'" @click="addWarning('see',scope.row)" type="text">查看</el-button>
                  <el-button v-permission="'monitor:accountMonitorLogList'" @click="recordsTable(scope.row)" type="text">记录</el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="paging-box" v-if="rulesPageTotal > 0">
              <el-pagination
                background
                @current-change="rulesCurrentChange"
                :current-page.sync="rulesTableParam.pageNum"
                :page-sizes="[10, 20, 40, 80, 100]"
                @size-change="handleSizeChange"
                :page-size="rulesTableParam.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="rulesPageTotal">
              </el-pagination>
            </div>
          </div>
          <!-- 智能托管 -->
          <div v-if="pageType === 1 || pageType === 2">
            <div class="table-name">已建规则</div>
            <el-form ref="queryFormRef" class="query-form" label-width="50px" :model="queryForm">
              <el-form-item label="筛选" style="width:100%;">
                <el-select v-model="queryForm.accountId" filterable clearable @change="aiMonitorChange" placeholder="请选择投放账户">
                  <el-option
                    v-for="item in accountList"
                    :key="item.id"
                    :label="item.agentAccountName"
                    :value="item.id">
                  </el-option>
                </el-select>
                <el-select v-model="queryForm.aiMonitorDimension" @change="aiMonitorChange" placeholder="监控维度">
                  <el-option v-if="pageType === 1" label="账户" :value="1"></el-option>
                  <el-option label="计划" :value="3"></el-option>
                </el-select>
                <el-select v-model="queryForm.configuratorId" filterable clearable @change="aiMonitorChange" placeholder="创建者">
                  <el-option
                    v-for="item in creatorList"
                    :key="item.configuratorId"
                    :label="item.configuratorName"
                    :value="item.configuratorId">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-input placeholder="请输入规则名称" v-model="queryForm.searchName" class="input-with-search">
                  <el-button @click="aiMonitorChange" slot="append" icon="iconfont icon-sousuo"></el-button>
                </el-input>
                <el-button @click="resetForm" type="info">重置选项</el-button>
              </el-form-item>
              <el-button @click="addWarning('add')" type="primary" class="fr" size="medium" icon="iconfont icon-tianjia-copy"
              v-permission="'monitor:addAiMonitor'">新建规则</el-button>
              <el-dropdown @command="handleCommand" class="fr" style="margin-right:10px;">
                <el-button :disabled="handleSelection.length == 0" type="primary" size="medium" class="" style="margin-left:0;">
                  批量修改状态<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="enable"> 启用 </el-dropdown-item>
                  <el-dropdown-item command="disable"> 暂停 </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-form>
            <el-table class="center-table roleTable" v-loading="tableLoading" :key="itemkey"
              :data="tableData" @selection-change="handleSelectionChange"
              border
              style="width: 100%">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column
                width="80px"
                prop="status"
                label="运行/暂停">
                <template slot-scope="scope">
                  <el-switch @change="changeStatus($event,scope.row)" v-model="scope.row.status"
                  :active-value="1" :inactive-value="0" v-permission="'monitor:updateAccountMonitorStatus'"></el-switch>
                </template>
              </el-table-column>
              <el-table-column
                prop="aiMonitorName"
                label="规则名称">
              </el-table-column>
              <el-table-column
                prop="agentAccountName"
                label="账户名称">
              </el-table-column>
              <el-table-column
                width="90px"
                prop="aiMonitorDimension"
                label="监控维度">
                <template slot-scope="scope">
                  <div v-if="scope.row.aiMonitorDimension===1">账户</div>
                  <div v-else-if="scope.row.aiMonitorDimension===2">广告组</div>
                  <div v-else-if="scope.row.aiMonitorDimension===3">计划</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="configuratorName"
                label="创建者">
              </el-table-column>
              <el-table-column
                width="160px"
                prop="createTime"
                label="创建时间">
              </el-table-column>
              <el-table-column
                prop="updateName"
                label="修改者">
              </el-table-column>
              <el-table-column
                width="160px"
                prop="updateTime"
                label="修改时间">
              </el-table-column>
              <el-table-column
                width="160px"
                prop=""
                label="操作">
                <template slot-scope="scope">
                  <el-button v-if="mgUpdateAccountMonitor || updateAiMonitor" @click="addWarning('edit',scope.row)" type="text">编辑</el-button>
                  <el-button v-permission="'monitor:getAiMonitorDetail'" @click="addWarning('see',scope.row)" type="text">查看</el-button>
                  <el-button v-permission="'monitor:accountMonitorLogList'" @click="recordsTable(scope.row)" type="text">记录</el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="paging-box" v-if="rulesPageTotal > 0">
              <el-pagination
                background
                @current-change="rulesCurrentChange"
                :current-page.sync="queryForm.pageNum"
                :page-sizes="[10, 20, 40, 80, 100]"
                @size-change="handleSizeChange"
                :page-size="queryForm.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="pageTotal">
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="触发记录" name="second" v-permission="'monitor:accountMonitorLogList'">
          <!-- 查询 -->
          <el-form class="query-form" label-width="50px" :model="recordsTableParam" style="margin-top:0.06rem;">
            <el-form-item label="搜索">
              <el-date-picker @change="changeTime"
                v-model="timeDate"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
              <el-select v-model="recordsTableParam.triggerRule" @change="changeTime" clearable placeholder="运行对象">
                <el-option
                    v-for="item in triggerRuleList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <!-- 触发记录--表格 -->
          <el-table class="center-table roleTable"
            :data="recordsTableData" v-loading="tableLoading"
            border
            style="width: 100%">
            <el-table-column fixed
              prop="alertTargetType"
              label="目标对象">
            </el-table-column>
            <el-table-column fixed min-width="160px"
              prop="alertTargetName"
              label="规则名称">
            </el-table-column>
            <el-table-column min-width="160px"
              prop="createTime"
              label="触发时间">
            </el-table-column>
            <el-table-column min-width="160px"
              prop="accountName"
              label="账户名称">
            </el-table-column>
            <el-table-column min-width="160px"
              prop="adName"
              label="计划名称">
              <template slot-scope="scope">
                <div v-if="scope.row.adName === ''">-</div>
                <div v-else>{{scope.row.adName}}</div>
              </template>
            </el-table-column>
            <el-table-column min-width="160px"
              prop="triggerRule"
              label="运行对象">
              <template slot-scope="scope">
                <div v-if="scope.row.alertType === 3">{{alertEventArr[scope.row.alertEventType]}}</div>
                <div v-else>{{scope.row.triggerRule}}</div>
              </template>
            </el-table-column>
            <el-table-column min-width="370"
              prop="alertMessage"
              label="满足条件">
              <template slot-scope="scope">
                <pre>{{scope.row.alertMessage}}</pre>
              </template>
            </el-table-column>
            <el-table-column min-width="120px"
              prop="triggerType"
              label="运行结果">
              <template slot-scope="scope">
                <div v-if="scope.row.triggerType === 1">通知</div>
                <div v-else-if="scope.row.triggerType === 2">通知/关停计划</div>
                <div v-else-if="scope.row.triggerType === 3">通知/开启计划</div>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="paging-box" v-if="recordsPageTotal > 0">
            <el-pagination
              background
              @current-change="recordsCurrentChange"
              :current-page.sync="recordsTableParam.pageNum"
              :page-sizes="[10, 20, 40, 80, 100]"
              @size-change="recordsSizeChange"
              :page-size="recordsTableParam.pageSize"
              layout="total, sizes, prev, pager, next"
              :total="recordsPageTotal">
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>
// 公用
import { handleTime, getLocalTime } from '@/components/public'
import { mapGetters } from 'vuex'
export default {
  name: 'monitorWarning',
  data () {
    return {
      itemkey: '', // 临时变量
      updateAccountMonitor: false,
      mgUpdateAccountMonitor: false,
      updateAiMonitor: false,
      tableLoading: true,
      activeName: 'first', // tab标签--选中的标签
      pageType: 3, // 选中的模块
      /* 规则管理标签数据 */
      rulesTableData: [], // 已创建的自动规则
      // 分页
      rulesPageTotal: 0,
      rulesTableParam: {
        projectId: 0,
        pageNum: 1,
        pageSize: 10
      },
      // 智能托管-查询表单
      queryForm: {
        projectId: 0,
        accountId: '', // 投放账户id
        aiMonitorDimension: '', // 智能监控维度1账号2广告组3计划
        aiMonitorType: '', // 智能监控类型1托管2止损
        configuratorId: '', // 创建者
        searchName: '', // 规则名称
        // 分页
        pageNum: 1,
        pageSize: 10 // 每页显示的数据条数
      },
      // 分页
      pageTotal: 0,
      tableData: [], // 托管/止损表格数据
      // 选择投放账户
      accountList: [],
      // 选择创建者
      creatorList: [],
      /* 触发记录标签数据 */
      recordsTableData: [], // 触发记录表格数据
      timeDate: [handleTime(new Date(), 6), handleTime(new Date())],
      recordsPageTotal: 0, // 分页-总条数
      recordsTableParam: { // 规则参数
        projectId: 0,
        timeStar: handleTime(new Date(), 6),
        timeEnd: handleTime(new Date()),
        triggerRule: '', // 运行对象
        pageNum: 1,
        pageSize: 10
      },
      triggerRuleList: [], // 运行对象数组
      // 目标维度
      alertTargetArr: ['广告账号', '广告组', '广告计划'],
      // 触发规则
      alertEventArr: [
        '', '广告账号余额下限', '广告账号消耗上限', '广告组预算波动', '广告组预算上限', '广告组消耗上限',
        '广告计划预算波动', '广告计划预算上限', '广告计划消耗上限', '广告计划出价波动', '广告计划出价上限'
      ],
      // 图片路径
      imgArr: {
        'imgStr1': require('@/assets/img/global_warning.png'),
        'imgStr2': require('@/assets/img/new_hosting.png'),
        'imgStr3': require('@/assets/img/control_AD.png'),
        'imgStr4': require('@/assets/img/increase_budget.png')
      },
      // 选中的行数据
      handleSelection: []
    }
  },
  created () {
    if (this.$route.path === '/monitor/monitorWarning') {
      // this.getTabelAccountMonitor()
      // this.updateType()
    }
    this.mgUpdateAccountMonitor = this.checkPermission('monitor:mgUpdateAccountMonitor')
    this.updateAccountMonitor = this.checkPermission('monitor:updateAccountMonitor')
    this.updateAiMonitor = this.checkPermission('monitor:updateAiMonitor')
  },
  mounted () {
    if (this.$route.path === '/monitor/monitorWarning') {
      this.updateType()
    }
  },
  computed: {
    ...mapGetters(['screeningProduct', 'screeningProject'])
  },
  methods: {
    // 切换项目筛选
    projectChange () {
      if (this.activeName === 'first') { // 规则管理
        if (this.pageType === 3) {
          this.getTabelAccountMonitor() // 获取规则管理表格数据
        } else if (this.pageType === 1 || this.pageType === 2) {
          this.getAccountCreatorList() // 获取账户和创建者
          this.getAiMonitorList() // 获取托管/止损监控规则列表
          this.queryForm.accountId = ''
        }
      } else { // 触发记录
        this.getTabelAccountMonitorLog()
      }
    },
    // 选中的行数据
    handleSelectionChange (val) {
      this.handleSelection = val
    },
    // 点选择状态按钮
    handleCommand (command) {
      let jsonData = {
        ids: [],
        status: command === 'enable' ? 1 : 0,
        aiMonitorType: this.pageType
      }
      this.handleSelection.forEach(item => {
        jsonData.ids.push(item.id)
      })
      this.$service.post('/api/accountMonitor/updateAccountMonitorStatus', jsonData).then(res => {
        if (res.code === 200) {
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.typeClick(this.pageType)
        } else if (res.code === 403) {
          this.$message({
            type: 'error',
            message: '您无此权限修改!'
          })
        } else {
          this.$message({
            type: 'error',
            message: res.message
          })
        }
      }).catch(Err => {})
    },
    // 刷新页面时保持页面模块不变
    updateType () {
      // 通过拿到的值不同，更改pageType的值
      if (this.$route.query.type === undefined || this.$route.query.type === 'NaN') {
        this.pageType = 3
        this.$route.query.type = 3
        this.typeClick(3)
      } else {
        this.pageType = parseInt(this.$route.query.type)
        this.typeClick(this.pageType)
      }
    },
    // 点击切换模块
    typeClick (num) {
      this.pageType = num
      // this.$route.query.type = num
      this.$router.push({
        path: '/monitor/monitorWarning',
        query: {
          type: num
        }
      })
      this.changeImageSrc(this.pageType)
      if (num === 3) {
        this.getTabelAccountMonitor()
      } else if (num === 1 || num === 2) {
        this.queryForm.aiMonitorType = this.pageType
        this.getAccountCreatorList() // 获取账户和创建者
        this.resetForm() // 获取托管/止损监控规则列表
      }
    },
    // 四个模块选中时的状态-hover
    changeImageSrc (key) {
      let hoverStr = '_active'
      switch (key) {
        case 1:
          this.imgArr.imgStr1 = require(`@/assets/img/global_warning.png`)
          this.imgArr.imgStr2 = require(`@/assets/img/new_hosting${hoverStr}.png`)
          this.imgArr.imgStr3 = require(`@/assets/img/control_AD.png`)
          this.imgArr.imgStr4 = require(`@/assets/img/increase_budget.png`)
          break
        case 2:
          this.imgArr.imgStr1 = require(`@/assets/img/global_warning.png`)
          this.imgArr.imgStr2 = require(`@/assets/img/new_hosting.png`)
          this.imgArr.imgStr3 = require(`@/assets/img/control_AD${hoverStr}.png`)
          this.imgArr.imgStr4 = require(`@/assets/img/increase_budget.png`)
          break
        case 3:
          this.imgArr.imgStr1 = require(`@/assets/img/global_warning${hoverStr}.png`)
          this.imgArr.imgStr2 = require(`@/assets/img/new_hosting.png`)
          this.imgArr.imgStr3 = require(`@/assets/img/control_AD.png`)
          this.imgArr.imgStr4 = require(`@/assets/img/increase_budget.png`)
          break
        case 4:
          this.imgArr.imgStr1 = require(`@/assets/img/global_warning.png`)
          this.imgArr.imgStr2 = require(`@/assets/img/new_hosting.png`)
          this.imgArr.imgStr3 = require(`@/assets/img/control_AD.png`)
          this.imgArr.imgStr4 = require(`@/assets/img/increase_budget${hoverStr}.png`)
          break
      }
    },
    // 点击tab标签
    handleClick (tab, event) {
      if (tab.index === '0') { // 规则管理
        this.rulesTableParam.pageNum = 1
        this.rulesTableParam.pageSize = 10
        this.getTabelAccountMonitor()
      } else { // 触发记录
        this.recordsTableParam = {
          timeStar: handleTime(new Date(), 6),
          timeEnd: handleTime(new Date()),
          triggerRule: '', // 运行对象
          pageNum: 1,
          pageSize: 10
        }
        this.getLogSelectList() // 获取运行对象
        this.getTabelAccountMonitorLog()
      }
    },
    // 新建、编辑、查看跳转
    addWarning (type, item) {
      if (this.pageType === 3) {
        if (item) {
          this.$router.push({path: '/monitor/monitorWarning/globalWarning', query: {'type': type, 'id': item.id, 'status': item.status}})
        } else {
          this.$router.push({path: '/monitor/monitorWarning/globalWarning', query: {'type': type}})
        }
      } else {
        let url = ''
        if (this.pageType === 1) {
          url = '/monitor/monitorWarning/intelligentManage'
        } else if (this.pageType === 2) {
          url = '/monitor/monitorWarning/stopRules'
        }
        if (item) {
          this.$router.push({path: url, query: {'type': type, 'pageType': this.pageType, 'id': item.id, 'status': item.status}})
        } else {
          this.$router.push({path: url, query: {'type': type, 'pageType': this.pageType}})
        }
      }
    },
    // 运行、暂停开关
    changeStatus (event, item) {
      item.status = item.status === 0 ? 1 : 0
      let jsonData = {
        ids: [item.id],
        status: event,
        aiMonitorType: this.pageType
      }
      this.$service.post('/api/accountMonitor/updateAccountMonitorStatus', jsonData).then(res => {
        if (res.code === 200) {
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          item.status = item.status === 0 ? 1 : 0
        } else if (res.code === 403) {
          this.$message({
            type: 'error',
            message: '您无此权限修改!'
          })
        }
      }).catch(Err => {})
    },
    // 托管、止损重置选项
    resetForm () {
      this.queryForm = {
        accountId: '', // 投放账户id
        aiMonitorDimension: '', // 智能监控维度1账号2广告组3计划
        aiMonitorType: '', // 智能监控类型1托管2止损
        configuratorId: '', // 创建者
        searchName: '', // 规则名称
        // 分页
        pageNum: 1,
        pageSize: 10 // 每页显示的数据条数
      }
      this.getAiMonitorList()
    },
    // 点记录跳转触发记录,获取表格数据
    recordsTable (item) {
      this.recordsTableParam = {
        accountId: item.accountId,
        alertTargetId: item.id,
        alertType: this.pageType,
        pageNum: 1,
        pageSize: 10,
        triggerRule: '',
        timeStar: handleTime(new Date(), 6),
        timeEnd: handleTime(new Date())
      }
      this.activeName = 'second'
      this.getLogSelectList() // 获取运行对象
      // 获取触发记录表格数据
      this.getTabelAccountMonitorLog()
    },
    // 切换分页--规则管理
    rulesCurrentChange (val) {
      if (this.pageType === 3) {
        this.getTabelAccountMonitor()
      } else {
        this.getAiMonitorList() // 获取托管/止损监控规则列表
      }
    },
    // 切换数据显示条数
    handleSizeChange (size) {
      if (this.pageType === 3) {
        this.rulesTableParam.pageSize = size
        this.getTabelAccountMonitor()
      } else {
        this.queryForm.pageSize = size
        this.getAiMonitorList() // 获取托管/止损监控规则列表
      }
    },
    // 获取规则管理表格数据
    getTabelAccountMonitor () {
      // 开启tableLoading
      this.tableLoading = true
      this.rulesTableParam.projectId = this.screeningProject
      this.$service.post('/api/accountMonitor/accountMonitorListData', this.rulesTableParam).then(res => {
        if (res.code === 200) {
          // 关闭tableLoading
          this.tableLoading = false
          this.itemkey = Math.random() // 在这边给key赋随机值，刷新表格
          this.rulesPageTotal = res.result.total
          this.rulesTableData = res.result.pageData
          this.rulesTableData.forEach((item, index) => {
            item.createTime = getLocalTime(new Date(item.createTime))
          })
        }
      }).catch(Err => {})
    },
    // 获取托管/止损监控规则列表
    getAiMonitorList () {
      this.queryForm.aiMonitorType = this.pageType
      this.queryForm.projectId = this.screeningProject
      // 开启tableLoading
      this.tableLoading = true
      this.$service.post('/api/accountMonitor/getAiMonitorList', this.queryForm).then(res => {
        if (res.code === 200) {
          // 关闭tableLoading
          this.tableLoading = false
          this.itemkey = Math.random() // 在这边给key赋随机值，刷新表格
          this.pageTotal = res.result.total
          this.tableData = res.result.pageData
          this.tableData.forEach((item, index) => {
            item.createTime = getLocalTime(new Date(item.createTime))
          })
        }
      }).catch(Err => {})
    },
    // 获取托管/止损列表下拉投放账户，创建者
    getAccountCreatorList () {
      this.$service.post('/api/accountMonitor/getAccountCreatorList', {platformType: parseInt(localStorage.platformType), aiMonitorType: this.pageType, projectId: this.screeningProject}).then(res => {
        if (res.code === 200) {
          this.accountList = res.result.account
          this.creatorList = res.result.creator
        }
      }).catch(Err => {})
    },
    // 托管/止损筛选
    aiMonitorChange () {
      this.queryForm.pageNum = 1
      this.getAiMonitorList()
    },
    // 触发记录-获取运行对象数组
    getLogSelectList () {
      this.$service.post('/api/accountMonitor/getLogSelectList').then(res => {
        if (res.code === 200) {
          this.triggerRuleList = res.result
        }
      }).catch(Err => {})
    },
    // 选择时间获取触发记录表格数据
    changeTime () {
      if (this.timeDate) {
        this.recordsTableParam.timeStar = this.timeDate[0]
        this.recordsTableParam.timeEnd = this.timeDate[1]
      } else {
        this.recordsTableParam.timeStar = ''
        this.recordsTableParam.timeEnd = ''
      }
      this.recordsTableParam.pageNum = 1
      this.getTabelAccountMonitorLog()
    },
    // 切换分页--触发记录
    recordsCurrentChange (val) {
      this.getTabelAccountMonitorLog()
    },
    // 切换数据显示条数
    recordsSizeChange (size) {
      this.recordsTableParam.pageSize = size
      this.getTabelAccountMonitorLog()
    },
    // 获取触发记录表格数据
    getTabelAccountMonitorLog () {
      this.recordsTableParam.projectId = this.screeningProject
      // 开启tableLoading
      this.tableLoading = true
      this.$service.post('/api/accountMonitor/accountMonitorLogListData', this.recordsTableParam).then(res => {
        if (res.code === 200) {
          // 关闭tableLoading
          this.tableLoading = false
          this.recordsPageTotal = res.result.total
          this.recordsTableData = res.result.pageData
          this.recordsTableData.forEach((item, index) => {
            item.createTime = getLocalTime(new Date(item.createTime))
            item.alertTargetType = this.alertTargetArr[item.alertTargetType - 1]
            // item.alertMessage = item.alertMessage.replace(/\n/g, '<br>')
            // let ind = item.alertMessage.lastIndexOf('触发监控设定:')
            // item.alertMessage = item.alertMessage.substring(ind + 7, item.alertMessage.length)
          })
        }
      }).catch(Err => {})
    }
  },
  watch: {
    // 监测弹窗
    $route (to) {
      if (to.path === '/monitor/monitorWarning') {
        this.getTabelAccountMonitor()
        this.updateType()
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import './../../styles/common/public.less';

// 规则管理
.el-row{
  margin: 0.06rem 0 0.09rem;
  border: 1px solid #F1F5F7;
  border-radius: 3px;
  .el-col-6{
    padding: 0.35rem 0.68rem 0.35rem 0.34rem;
    // margin-right: 0.3rem;
    position: relative;
    &::after{
      content: " ";
      display: block;
      width: 2px;
      background: linear-gradient(to right,@themeColor,#479EFF);
      height: 40%;
      position: absolute;
      top: 30%;
      right: 0.34rem;
    }
    .grid-content{
      border-radius: 5px;
      padding: 0.3rem;
      text-align: center;
      cursor: pointer;
      &.active{
        background: linear-gradient(to right,@themeColor,#479EFF);
        cursor: pointer;
        .grid-name{
          color: #fff;
        }
      }
      >img{
        width: 100%;
      }
      .grid-name{
        color: @fontColor;
        font-size: 16px;
        margin-top: 0.22rem;
      }
    }
  }
}
.table-name{
  font-weight: bold;
  font-size: 16px;
  margin: 3px 0 10px;
}
.bgfff.el-button--info{
  background-color: #fff;
}
.bgfff.el-button--info.is-disabled{
  color: #999;
}
.el-button--info.is-disabled:hover {
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/monitor/monitorWarning.vue